import React from 'react'
import RateWidgetFooter from 'components/footer'
import { ThemeContext } from '@cred/react-theme'
import { RateScript as Rate } from '@cred/react-rate/rate-script'
import Font from '@cred/react-font'
import logo from '@cred/global-assets/images/logos/credible/logo-blue.svg'
import BaseFullRateTable from '../base'
import { PERSONAL_LOAN_HEADER_TEXT } from '../../constants'
import styles from './styles.scss'

const FoxFullRateTable = props => (
  <ThemeContext.Provider value="default">
    <div className={styles.fullDefaultRateTableRoot}>
      <div className={styles.headerContainer}>
        <img src={logo} className={styles.logo} alt="Credible" />
        <Font
          type="medium"
          weight="bold"
          color="accent2"
          className="mb-8 mt-8"
        >
          {PERSONAL_LOAN_HEADER_TEXT}
        </Font>
        <Font>
          Rates from <Rate rateType="apr" vertical="personal" variable={false} name="min" /> fixed
            APR with loans from $1,000 to $100,000
        </Font>
      </div>
      <BaseFullRateTable
        {...props}
        theme="default"
        lenderListClassName={styles.lenderListRoot}
        filterFormClassName={styles.filterFormRoot}
      />
      <RateWidgetFooter containerClass={styles.footerContainerClass} theme="default" />
    </div>
  </ThemeContext.Provider>
)

export default FoxFullRateTable
